import { render } from "./InsightsVocabulary.vue?vue&type=template&id=a20b5858&scoped=true"
import script from "./InsightsVocabulary.vue?vue&type=script&lang=js"
export * from "./InsightsVocabulary.vue?vue&type=script&lang=js"

import "./InsightsVocabulary.vue?vue&type=style&index=0&id=a20b5858&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a20b5858"]])

export default __exports__